import { render, staticRenderFns } from "./NewsBox.vue?vue&type=template&id=1024062a&scoped=true&"
import script from "./NewsBox.vue?vue&type=script&lang=js&"
export * from "./NewsBox.vue?vue&type=script&lang=js&"
import style0 from "./NewsBox.vue?vue&type=style&index=0&id=1024062a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024062a",
  null
  
)

export default component.exports